import { reactive, ref, Ref } from 'vue'
import { ApiResponse, ApiPaymentResponse } from '@/contracts/api/ResponseContracts'
import axios from 'axios'

export function axiosGet(url: string, params?: Record<string, unknown>): ApiResponse
{
    const data = reactive({} as ApiResponse)
    const axiosInstance = axios.create(
    {
        headers:
        {
            skipAggregates: 'true',
            'enrichers-document': 'thumbnail, permissions, highlight',
            'translate-directoryEntry': 'label',
            'fetch-aggregate': 'key',
            properties: 'hmcts_grant_schema',
            'fetch-document': 'properties'
        }
    })

    let queryString = ''
    if(params)
    {
        queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&')
        console.log(queryString)
    }

    axiosInstance.get(process.env.VUE_APP_API_DOMAIN + url + '?' + queryString).then((response) =>
    {
        // Log in non-production:
        if(process.env.NODE_ENV !== 'production')
        {
            console.log(response.data)
        }
        // Set data:
        Object.assign(data, response.data)
    }).catch(function(error)
    {
        handleError(error)
    })

    return data
}

export function axiosDownload(url: string): Ref
{
    const data = ref('')
    const axiosInstance = axios.create(
    {
        responseType: 'blob'
    })

    axiosInstance.get(process.env.VUE_APP_API_DOMAIN + url).then((response) =>
    {
        // Log in non-production:
        if(process.env.NODE_ENV !== 'production')
        {
            console.log(response.data)
        }
        // Set data:
        data.value = response.data
    }).catch(function(error)
    {
        handleError(error)
    })

    return data
}

export function axiosGetPayment(url: string): ApiPaymentResponse
{
    const data = reactive({} as ApiPaymentResponse)
    const axiosInstance = axios.create({})

    axiosInstance.get(process.env.VUE_APP_API_DOMAIN + url).then((response) =>
    {
        // Log in non-production:
        if(process.env.NODE_ENV !== 'production')
        {
            console.log(response.data)
        }
        // Set data:
        Object.assign(data, response.data)
    }).catch(function(error)
    {
        handleError(error)
    })

    return data
}

export function axiosPostPayment(url: string, postData: Record<string, unknown>): ApiPaymentResponse
{
    const data = reactive({} as ApiPaymentResponse)
    const axiosInstance = axios.create({})

    axiosInstance.post(process.env.VUE_APP_API_DOMAIN + url, postData).then((response) =>
    {
        // Log in non-production:
        if(process.env.NODE_ENV !== 'production')
        {
            console.log(response.data)
        }
        // Set data:
        Object.assign(data, response.data)
    }).catch(function(error)
    {
        handleError(error)
    })

    return data
}

// Handle error in axios:
function handleError(error: any): void
{
    // Look for response in error:
    if(error.response)
    {
        // Log in non-production:
        if(process.env.NODE_ENV !== 'production')
        {
            // console.log(error.response.data)
            console.log(error.response.status)
            console.log(error.response.headers)
        }
    }
    // Request was made, but no response received:
    else if(error.request)
    {
        // Log in non-production:
        if(process.env.NODE_ENV !== 'production')
        {
            console.log(error.request)
        }
    }
    // Something happened in setting up the request that triggered an error:
    else
    {
        // Log in non-production:
        if(process.env.NODE_ENV !== 'production')
        {
            console.log('Error', error.message)
        }
    }
    // Log in non-production:
    if(process.env.NODE_ENV !== 'production')
    {
        console.log(error.config)
    }
}
